var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("UiButtonMessage", {
    attrs: {
      processing: _vm.processing,
      label: "add light-gray",
      buttonClass: _vm.buttonClasses,
    },
    on: { click: _vm.add },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }